import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { ShiftModel } from 'src/app/modules/information/shift';
import { ApiService } from 'src/app/Services/api.service';
import { CommonServices } from 'src/app/Services/common.service';
import { StorageService } from 'src/app/Services/storage.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';

import { OrgBranchStateManagement } from './../../../../../../store/branch/reducer';

declare const Swal;

@Component({
  selector: 'app-list-shift',
  templateUrl: './list-shift.component.html',
  styleUrls: ['./list-shift.component.css']
})
export class ListShiftComponent implements OnInit {
  public shiftInformation: any = [];
  public branchInformation = [];
  public searchInput: any = new Subject<string>();
  searchedValue = "";
  serchKey: any = "shiftName";
  // total$: Observable<number>;
  total$ = 190;
  items$: Observable<any>;

  terms: string = "";
  private searchTermStream = new Subject<string>();

  page: number = 1;
  private pageStream = new Subject<number>();
  noDataEnable: boolean = false;
  readonly pageLimit: number = 10;

  constructor(
    public api: ApiService,
    public storage: StorageService,
    public router: Router,
    public swal: SweetAlert,
    public comservice: CommonServices,
    private branchState: OrgBranchStateManagement
  ) {
    this.branchState.fetchBranchList();
  }

  ngOnInit(): void {
    this.getListShift();
    // this.getBranchList();
    // this.total$ = 40
  }

  get filteredShiftInformation(): any[] {
    if (!this.shiftInformation || !this.shiftInformation.length) {
      return [];
    }
    const term = String(this.searchedValue || '').trim().toLowerCase();
    if (!term) {
      return this.shiftInformation;
    }
    return this.shiftInformation.filter((item: any) =>
      String(item?.[this.serchKey] || '').toLowerCase().includes(term)
    );
  }

  get paginatedShiftInformation(): any[] {
    const startIndex = (this.page - 1) * this.pageLimit;
    return this.filteredShiftInformation.slice(startIndex, startIndex + this.pageLimit);
  }

  get totalPages(): number {
    return Math.max(1, Math.ceil(this.filteredShiftInformation.length / this.pageLimit));
  }

  onSearchChange(value: string): void {
    this.searchedValue = value;
    this.page = 1;
  }

  onPageChange(type: 'prev' | 'next'): void {
    if (type === 'prev' && this.page > 1) {
      this.page -= 1;
      return;
    }
    if (type === 'next' && this.page < this.totalPages) {
      this.page += 1;
    }
  }
  getListShift() {
    this.shiftInformation = [];
    const obj = {
      orgID: this.storage.get('userInfo').orgID
    };
    this.api.ListShift(obj).then((res: any) => {
      console.log(res);
      if (res.status == 'success') {
        res.data.map((item)=>{
          let obj = { ...item};
          if(item['startTime']) item['startTime'] = this.getTimeString(item['startTime']);
          if(item['endTime']) item['endTime'] = this.getTimeString(item['endTime']);
          this.shiftInformation.push(obj);
        });
        this.page = 1;
        this.noDataEnable = true;
      }
      else this.noDataEnable = true;
    }).catch((err) => {
      console.log(err);
    });
  }
  getBranchList() {
    const obj = {
      orgID: this.storage.get('userInfo').orgID
    };
    this.api.transportManagerBranchList(obj).then((res: any) => {
      console.log(res);
      if (res.status == 'success') {
        this.branchInformation = res.data;
        this.noDataEnable = true;
      }
    }).catch((err) => {
      console.log(err);
    });
  }

  // getBranchName(id) {
  //   let name = '';
  //   console.log('#########');
  //   this.branchInformation.filter((e) => {
  //     if (e.branchID == id) {
  //       name = e.branchName;
  //     }
  //   });
  //   return name;
  // }

  getTimeString(time) {                             // time '10:20 AM'
    let timeString = time;
    let splitTime = timeString.split(":");            // 10, 20 AM
    let splitMinute = splitTime[1].split(' ');      // 20, AM
    let hour = this.comservice.pad(Number(splitTime[0]));
    let minute = this.comservice.pad(Number(splitMinute[0]));
    let meriden = splitMinute[1];
    let timeformat = `${hour}:${minute} ${meriden}`;
    return timeformat;
  }

  deleteShiftData(e: any) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to delete this!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',//'#3085d6',
      //  cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        console.log('delete click');
        this.deleteShift(e);
        Swal.fire(
          'Deleted!',
          'Your file has been deleted.',
          'success'
        );
      }
    });
  }
  deleteShift(e: any) {
    console.log(e);
    const obj = {
      orgID: this.storage.get('userType').orgID,
      shiftID: e.shiftID
    };
    this.api.DeleteShift(obj).then((res: any) => {
      console.log(res);
      if (res.status == 'success') { this.getListShift(); }
      if (res.status == 'failure') { this.swal.swalFunction('error', res.status, res.message, 2000); }

    }).catch((err) => {
      console.log(err);
    });
  }
  editShiftData(e: any) {
    this.router.navigate(['/organization/transport-manager/information/orgInfo/shift/edit-shift', e.shiftID]);
    console.log(e);
  }
  viewShift(item) {
    console.log(item);
  }

}
